<template>
    <div class="relative">
        <button
            @click="isOpen = !isOpen"
            class="flex items-center space-x-2 px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
        >
            <span class="text-sm font-medium">{{ currentLanguage }}</span>
            <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>

        <div
            v-if="isOpen"
            class="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5"
        >
            <div class="py-1">
                <button
                    v-for="lang in languages"
                    :key="lang.code"
                    @click="changeLanguage(lang.code)"
                    class="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                    :class="{
                        'bg-gray-100 dark:bg-gray-700':
                            currentLanguage === lang.name
                    }"
                >
                    {{ lang.name }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LanguageSelector",
    data() {
        return {
            isOpen: false,
            currentLanguage: "Español",
            languages: [
                { code: "es", name: "Español" },
                { code: "en", name: "English" }
            ]
        };
    },
    methods: {
        changeLanguage(langCode) {
            this.currentLanguage = this.languages.find(
                (lang) => lang.code === langCode
            ).name;
            this.$i18n.locale = langCode;
            this.isOpen = false;
        }
    },
    mounted() {
        document.addEventListener("click", (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOpen = false;
            }
        });
    }
};
</script>
